/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetCostTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCostTypesQuery = {
  __typename?: 'Query',
  costTypes?: Array<{
    __typename?: 'CostType',
    id: number,
    title_en?: string | null,
    title_nl?: string | null,
    title_de?: string | null
  }> | null
};


export const GetCostTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCostTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"costTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_nl"}},{"kind":"Field","name":{"kind":"Name","value":"title_de"}}]}}]}}]} as unknown as DocumentNode<GetCostTypesQuery, GetCostTypesQueryVariables>;